import type { ToRelativeOptions } from 'luxon';
import { capitalizeFirstLetter } from '@olivierpascal/helpers';
import stylex from '@stylexjs/stylex';
import { DateTime } from 'luxon';
import { Trans, useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';

export type IRelativeTimeProps = IContainerProps & {
  date?: DateTime;
  isoDate?: string;
  i18nKey?: string;
  i18nParamName?: string;
  options?: ToRelativeOptions;
  firstLetterCapitalized?: boolean;
};

export const RelativeTime: React.FC<IRelativeTimeProps> = (props) => {
  const {
    sx,
    date: dateProp,
    isoDate,
    i18nKey,
    i18nParamName = 'relativeTime',
    options,
    firstLetterCapitalized,
  } = props;
  const { i18n } = useTranslation();
  const locale = i18n.language;
  const date = dateProp ?? (isoDate ? DateTime.fromISO(isoDate) : undefined);
  const fullDate = date?.toLocaleString(DateTime.DATETIME_FULL_WITH_SECONDS, {
    locale,
  });
  const relativeTime = date
    ? date.toRelative({ locale, ...options })
    : undefined;
  const formattedRelativeTime =
    relativeTime && firstLetterCapitalized
      ? capitalizeFirstLetter(relativeTime)
      : relativeTime;

  return (
    <div {...stylex.props(sx)} title={fullDate}>
      {i18nKey ? (
        <Trans
          i18nKey={i18nKey}
          values={{ [i18nParamName]: formattedRelativeTime }}
        />
      ) : (
        formattedRelativeTime
      )}
    </div>
  );
};
